import { paths } from "../../../config/routes";
import { push } from "connected-react-router";
import {
  requestPasswordApi,
  sendApi,
  validateTokenApi,
  changePassApi,
} from "../../../services/passRecoveryApi";
import { openCloseToast } from "../../Global/actions";
import {
  envioEmailSMSActivacionCuenta,
  validarIdentidadUsuario,
  validarIdentidadUsuarioNoSerie,
  envioEmailSMSActivacionCuentaNoSerie,
} from "../../../services/ValidacionIdentidad";
import validaciones from "../../../helpers/validaciones";
import { setUserInfo, userRegisterStep } from "../Registro/actions";
import {
  doCotizacionesService,
  doValidateSerivice,
} from "../../../services/registroApi";
import axios from "axios";
import { statusMessages, validacionUsuarioFlujos } from "./statusMessages";
import { REGISTRAR_USUARIO } from "../../../helpers/statusCuentaUsuario";
import swal from "../../../helpers/swal.lib";

const serialCIActivacion = () => sessionStorage.getItem("serialCIActivacion");
const rutUsuarioActivacion = () =>
  sessionStorage.getItem("rutUsuarioActivacion");

export const changeStep = (newStep) => ({
  type: "CHANGE_STEP",
  newStep,
});

export const enableNext = () => ({
  type: "ENABLE_NEXT",
});

export const disableNext = () => ({
  type: "DISABLE_NEXT",
});

export const loading = (isLoading) => ({
  type: "LOADING_RECUPERAR_PASSWORD",
  isLoading,
});

export const resetState = () => ({
  type: "RESET_STATE",
});

export const setUserOptions = ({ Email, CellPhoneNumber, IsTemporalUser }) => ({
  type: "SET_USER_OPTIONS",
  Email,
  CellPhoneNumber,
  IsTemporalUser,
});

export const setCodeError = (error) => ({
  type: "SET_CODE_ERROR",
  error,
});

export const setUserInfoError = (error) => ({
  type: "SET_INFO_USER_ERROR",
  error,
});

export const setTypeSelected = (typeSelected) => ({
  type: "SET_TYPE_SELECTED",
  typeSelected,
});

export const setStatusAccount = (
  Status,
  Message,
  Email,
  Phone,
  EmailMasked,
  PhoneMasked
) => ({
  type: "SET_ACCOUNT_STATUS",
  Status,
  Message,
  Email,
  Phone,
  EmailMasked,
  PhoneMasked,
});

export const doGetUserOptions = (user) => async (dispatch) => {
  dispatch(loading(true));
  try {
    const options = await requestPasswordApi(user);
    if (options.status === 200) {
      const result = await options.json();
      if (result.Success && result.UserInfo !== null) {
        dispatch(setUserOptions(result.UserInfo));
        dispatch(changeStep(1));
      } else {
        dispatch(
          setUserInfoError(
            "Usuario invalido. Comprueba el Rut o correo electrónico."
          )
        );
      }
    } else {
      dispatch(
        openCloseToast({
          isToastOpen: true,
          msgToast: "Error al obtener opciones",
          typeStyle: "error",
          displayTime: 1000
        })
      );
    }
  } catch (error) {
    dispatch(
      openCloseToast({
        isToastOpen: true,
        msgToast: "Error al obtener opciones",
        typeStyle: "error",
        displayTime: 1000
      })
    );
  }
  dispatch(loading(false));
};

export const doSendCode = (selected, email, isTemporal) => async (dispatch) => {
  dispatch(loading(true));
  try {
    let type = "SMS";
    if (selected.indexOf("@") !== -1) type = "EMAIL";

    dispatch(setTypeSelected(type));

    const response = await sendApi({ email, isTemporal, type });
    if (response.status === 200) {
      dispatch(changeStep(2));
    } else {
      dispatch(
        openCloseToast({
          isToastOpen: true,
          msgToast: "Error al enviar el código",
          typeStyle: "error",
          displayTime: 1000
        })
      );
    }
  } catch (error) {
    dispatch(
      openCloseToast({
        isToastOpen: true,
        msgToast: "Error al enviar el código",
        typeStyle: "error",
        displayTime: 1000
      })
    );
  }
  dispatch(loading(false));
};

export const doValidateCode = (code, email) => async (dispatch) => {
  dispatch(loading(true));
  try {
    const response = await validateTokenApi({ email, token: code });
    if (response.status === 200) {
      const result = await response.json();
      if (result.IsValid) {
        dispatch(changeStep(3));
      }
    } else {
      dispatch(setCodeError(true));
    }
  } catch {
    dispatch(
      openCloseToast({
        isToastOpen: true,
        msgToast: "Error al validar el codigo",
        typeStyle: "error",
        displayTime: 1000
      })
    );
  }
  dispatch(loading(false));
};

export const doChangePassword = ({
  email,
  code,
  isTemporal,
  pass,
  passConfirmation,
}) => async (dispatch) => {
  dispatch(loading(true));
  try {
    const response = await changePassApi({
      email,
      token: code,
      isTemporal,
      pass,
      passConfirmation,
    });
    if (response.status === 200) {
      dispatch(changeStep(4));
    } else {
      dispatch(
        openCloseToast({
          isToastOpen: true,
          msgToast: "Error al cambiar la contraseña",
          typeStyle: "error",
          displayTime: 1000
        })
      );
    }
  } catch {
    dispatch(
      openCloseToast({
        isToastOpen: true,
        msgToast: "Error al cambiar la contraseña",
        typeStyle: "error",
        displayTime: 1000
      })
    );
  }
  dispatch(loading(false));
};

/**
 * @description Action para validar la identidad del usuario y
 * realizar la redirección a la pantalla indicada para resolver los
 *  problemas de la cuenta
 */
export const validacionIdentidadAction = (
  redireccion,
  validarIdentidadUsuarioRequest,
  flujo
) => async (dispatch, getState) => {
  dispatch(loading(true));

  const {
    REGISTRAR_USUARIO,
    CEDULA_VENCIDA_NO_VIGENTE,
    ACTIVAR_CUENTA,
    RESTABLECER_CONTRASEÑA,
    VALIDACION_IDENTIDAD_INCORRECTA,
  } = statusMessages;

  const response = await (await validarIdentidadUsuarioRequest()).json();

  const responseModified = { ...response };
  if (response.Status == VALIDACION_IDENTIDAD_INCORRECTA) {
    responseModified.Payload = {
      Email: "",
      Phone: "",
      EmailMasked: "",
      PhoneMasked: "",
    };
  }

  if (
    flujo === validacionUsuarioFlujos.restablecerContraseñaConValidacion &&
    responseModified.Status == RESTABLECER_CONTRASEÑA
  ) {
    responseModified.Status = 800;
  }

  if (
    flujo === validacionUsuarioFlujos.restablecerContraseñaConValidacion &&
    responseModified.Status == ACTIVAR_CUENTA
  ) {
    responseModified.Status = 801;
  }

  if (
    flujo === validacionUsuarioFlujos.restablecerContraseñaConValidacion &&
    responseModified.Status == REGISTRAR_USUARIO
  ) {
    const responseDatosUsuario = await (await doCotizacionesService()).json();
    dispatch(setUserInfo(responseDatosUsuario));
    const steps = {
      stepThree: true, // Redirige a la pantalla ValidarDatosPersonales
    };
    dispatch(userRegisterStep(steps));
    dispatch(push(paths.registro));
  }
  if (
    responseModified.Status == RESTABLECER_CONTRASEÑA
  ) {
    responseModified.Status = 2;
      dispatch(
      resolveNoSerieRestablecerConstraseñaAction(
        {
          Phone: response.Payload.Phone,
          Email: response.Payload.Email,
          NotificationType: 3,
        },
        3
      )
    )
  }
  const {
    Status,
    Message,
    Payload: { Email, Phone, EmailMasked, PhoneMasked } = {},
  } = responseModified;

  //Logica para el flujo de registro originalssss
  if (redireccion == "registro") {
    if (response.Status == REGISTRAR_USUARIO) {
      const responseDatosUsuario = await (await doCotizacionesService()).json();
      dispatch(setUserInfo(responseDatosUsuario));
      //Redireccion al flujo original de registro de usuarios
      const steps = {
        stepThree: true, // Redirige a la pantalla ValidarDatosPersonales
      };
      dispatch(userRegisterStep(steps));
      dispatch(push(paths.registro));
    } else {
      dispatch(
        setStatusAccount(
          Status,
          Message,
          Email,
          Phone,
          EmailMasked,
          PhoneMasked
        )
      );
      dispatch(push(paths.recuperarContraseña));
    }
  } else {
    dispatch(
      setStatusAccount(Status, Message, Email, Phone, EmailMasked, PhoneMasked)
    );
  }
  dispatch(loading(false));
};

/**
 * @description Este se action se encarga de gatillar el servicio de envio
 * de email y SMS para la activación de cuentas cuando el usuario esta registrado
 * pero su cuenta no esta activa
 *
 */
export const EnvioEmailSMSActivacionCuenta = (
  datos,
  step,
  envioEmailSMSActivacionCuenta,
  impedirNavegacion
) => async (dispatch, getState) => {
  dispatch(loading(true));
    const solicitud = await envioEmailSMSActivacionCuenta(datos);
    if(solicitud.status === 200) {
      const { recover } = getState();
      if (datos) {
        recover.email = datos.Email;
        recover.phone = datos.Phone;
        const regexEmail = '(.+)@(.+$)';
        const emailMasked = datos.Email.match(regexEmail);
        if(emailMasked)
          recover.emailMasked = `${emailMasked[1].substring(0, emailMasked[1].length/2)}${'*'.repeat(emailMasked[1].length/2)}@${emailMasked[2]}`;
        const regexPhone = /[+]?[56]?\d*(\d{4})/;
        const phoneMasked = datos.Phone.match(regexPhone);
        if(phoneMasked)
          recover.phoneMasked = `+56******${phoneMasked[1]}`;
      }

      const { email, phone, mensaje, statusCuenta, emailMasked, phoneMasked } = recover;

      if (step == 3) {
        dispatch(setStatusAccount(2, mensaje, email, phone, emailMasked, phoneMasked));
      } else {
        const steps = {
          stepOne: false,
          stepTwo: false,
          stepThree: false, // Redirige a la pantalla ValidarDatosPersonales
          stepFour: false,
          stepSuccess: false,
          stepSix: true, //Renderiza a la pantalla de reenvio Email/SMS de activación de cuenta
        };

        if(!impedirNavegacion)
        {
          dispatch(setStatusAccount(statusCuenta, mensaje, email, phone));
          dispatch(userRegisterStep(steps));
          dispatch(push(paths.registro));
        }
      }
  }
  else {
    const res = await solicitud.json();
    if(res.Error.toUpperCase() === "EMAIL ALREADY EXISTS") {
      swal.alertConfirm(null, "El correo ingresado ya se encuentra registrado.<br />Por favor utilizar otro correo.");
    }
  }
  dispatch(loading(false));
};

/**
 * @description Action para consumir el nuevo endpoint con el servicio de cotizaciones y
 * consultar información del usuario,así como setear la redirección a la pantalla
 * de registro y precargar los datos
 * @author Tony Krikorian <tkrikoriam@achs.cl>
 */
export const renderBody = (statusCuenta) => async (dispatch, getState) => {
  dispatch(loading(true));
  const { recover } = getState();

  //Recuperacion contraseña
  if (statusCuenta == 200) {
    recover.statusCuenta = 800;
    const { email, phone, mensaje, statusCuenta } = recover;
    dispatch(setStatusAccount(statusCuenta, mensaje, email, phone));
  } else if (statusCuenta == 400) {
    //Registrar usuario
    const steps = {
      stepThree: true, // Redirige a la pantalla ValidarDatosPersonales
    };
    const response = await (await doCotizacionesService()).json();
    dispatch(setUserInfo(response));
    dispatch(userRegisterStep(steps));
    dispatch(push(paths.registro));
  }
  if (statusCuenta == 401) {
    //Flujo activar cuenta
    recover.statusCuenta = 801;
    const { email, phone, mensaje, statusCuenta } = recover;
    dispatch(setStatusAccount(statusCuenta, mensaje, email, phone));
  }
  dispatch(loading(false));
};

export const renderRedirectFlujoValidacionIdentidad = () => async (
  dispatch,
  getState,
  navegar
) => {
  const { recover } = getState();

  /**
   * Sí el status de la cuenta es registrar usuarios,
   * entonces redireccionar ala validación de identidad
   */
  if ((recover.statusCuenta = REGISTRAR_USUARIO)) {
    recover.statusCuenta = 802;
  }
  const { email, phone, mensaje, statusCuenta } = recover;
  dispatch(setStatusAccount(statusCuenta, mensaje, email, phone));
  dispatch(push(paths.recuperarContraseña));
};

export const resolveNoSerieRestablecerConstraseñaAction = (
  datos,
  step
) => async (dispatch, getState) => {
  dispatch(loading(true));
  await envioEmailSMSActivacionCuentaNoSerie();
  const { recover } = getState();
  recover.email = datos.Email;
  recover.phone = datos.Phone;
  const { email, phone, mensaje, statusCuenta, emailMasked, phoneMasked } = recover;

  if (step == 3) {
    //dispatch(setStatusAccount(2, mensaje, email, phone, emailMasked, phoneMasked));
  } else {
    const steps = {
      stepOne: false,
      stepTwo: false,
      stepThree: false, // Redirige a la pantalla ValidarDatosPersonales
      stepFour: false,
      stepSuccess: false,
      stepSix: true, //Renderiza a la pantalla de reenvio Email/SMS de activación de cuenta
    };
    dispatch(setStatusAccount(statusCuenta, mensaje, email, phone));
    dispatch(userRegisterStep(steps));
    dispatch(push(paths.registro));
  }
  dispatch(loading(false));
};
/**
 * @description Este action se usa unicamente para el reenvio del
 * sms/email para restablecimiento de contraseña
 * @returns
 */
export const ReenviarCodigoActivacionSMS = () => async (dispatch) => {
  dispatch(loading(true));
  try {
    const response = await (
      await envioEmailSMSActivacionCuentaNoSerie()
    ).json();
    if (response.Status === 200) {
      // console.log(response);
    } else {
      dispatch(
        openCloseToast({
          isToastOpen: true,
          msgToast: "Error al enviar el código",
          typeStyle: "error",
          displayTime: 1000
        })
      );
    }
  } catch (error) {
    dispatch(
      openCloseToast({
        isToastOpen: true,
        msgToast: "Error al enviar el código",
        typeStyle: "error",
        displayTime: 1000
      })
    );
  }
  dispatch(loading(false));
};
